import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useLanguageStore = defineStore('language', () => {
    const lang = ref('RU')

    function updateLanguage(payload) {
        localStorage.setItem('ASW_LANG', payload)
        lang.value = payload
    }

    return {
        lang,
        updateLanguage
    }
})
